import React from "react";
import "../App.css";

const scrollToId = (id) => (e) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Navbar() {
    return (
        <div className="nav">
            <div className="container navInner">
                <div className="brandTop">
                    <img src="/logo512.png" alt="Esküvő logó" style={{ height: 60 }} />
                    <span className="scriptGold">Elíz és Gergő</span>
                </div>

            <div className="navLinks">
                <a href="#helyszin" onClick={scrollToId("helyszin")}>Helyszínek</a>
                <a href="#program" onClick={scrollToId("program")}>Program</a>
                <a href="#menu" onClick={scrollToId("menu")}>Menü</a>
                <a href="#rsvp" onClick={scrollToId("rsvp")}>Visszajelzés</a>
                <a href="#faq" onClick={scrollToId("faq")}>Tudnivalók</a>
            </div>
            </div>
        </div>
    );
}
